import type { ComponentType, SVGProps, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

interface PageHeaderProps {
  icon: ComponentType<SVGProps<SVGSVGElement> & { className?: string }>;
  iconColor?: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  actionTo?: string;
  actionLabel?: string;
}

export function PageHeader({
  icon: Icon,
  iconColor = 'text-purple-500',
  title,
  subtitle,
  action,
  actionTo,
  actionLabel,
}: PageHeaderProps) {
  const button = action || (actionTo ? (
    <Link to={actionTo}>
      <Button className="h-10 gap-2">
        <span className="hidden sm:inline">{actionLabel}</span>
        <span className="sm:hidden">{actionLabel?.replace(/^Add /, '')}</span>
      </Button>
    </Link>
  ) : null);

  return (
    <div className="flex items-center justify-between gap-2">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-light-text dark:text-dark-text flex items-center gap-2">
          <Icon className={`w-5 h-5 sm:w-6 sm:h-6 ${iconColor}`} />
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs sm:text-sm text-light-text-muted mt-1">{subtitle}</p>
        )}
      </div>
      {button}
    </div>
  );
}
